export enum UserDeviceActivityType {
  Signup = 'signup',
  Login = 'login',
  Deposit = 'deposit',
  Withdraw = 'withdraw',
  VpnCheck = 'vpn-check',
}
